'use strict';

var Promise = require('bluebird');

module.exports = function (url) {
  return Promise.resolve($.ajax({
    url: url,
    type: 'GET',
    dataType: 'html',
    cache: true,
    beforeSend: function (jqXHR, settings) {
      jqXHR.url = settings.url;
    }
  }));
};
